import { OrganisationService } from "../services/OrganisationService";
import { UserService } from "../services/UserService";

/**
 * Service class for data coordination and refresh operations
 */
export class DataService {
  static async refreshData(email, sub) {
    if (!email || !sub) {
      return;
    }

    await UserService.fetchUser(email, sub);

    let organisations = await OrganisationService.fetchOrganisations();
    let orgID = localStorage.getItem("selectedOrganisationID");

    if (!orgID || orgID === "") {
      orgID = await this.getFirstOrganisationID(organisations);
      localStorage.setItem("selectedOrganisationID", orgID);
    }

    let devicesPerPage = localStorage.getItem("devicesPerPage");
    if (!devicesPerPage) {
      devicesPerPage = 10;
      localStorage.setItem("devicesPerPage", devicesPerPage);
    } else {
      if (isNaN(parseInt(devicesPerPage))) {
        devicesPerPage = 10;
        localStorage.setItem("devicesPerPage", devicesPerPage);
      }
    }

    if (organisations && organisations.length) {
      let selectedOrganisation = {};

      //check if selectedOrganisationID is valid and an option of organisations
      if (
        organisations.find((org) => org.id === parseInt(orgID)) === undefined
      ) {
        selectedOrganisation = organisations[0];
        localStorage.setItem("selectedOrganisationID", selectedOrganisation.id);
        orgID = selectedOrganisation.id;
      } else {
        selectedOrganisation =
          organisations.find((org) => org.id === parseInt(orgID)) || {};
      }

      // Return organization data for TanStack Query to handle
      return {
        selectedOrganisation,
        orgID,
        organisations,
      };
    }

    return null;
  }

  static async getFirstOrganisationID(organisations) {
    if (organisations && organisations.length) {
      const orgID = organisations[0].id;
      return orgID;
    }

    organisations = await OrganisationService.fetchOrganisations();

    if (organisations && organisations.length) {
      const orgID = organisations[0].id;
      return orgID;
    }

    return null;
  }
}
